/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthIntegrationCredentialsType } from './PalAuthIntegrationCredentialsType';
import {
    PalAuthIntegrationCredentialsTypeFromJSON,
    PalAuthIntegrationCredentialsTypeFromJSONTyped,
    PalAuthIntegrationCredentialsTypeToJSON,
    PalAuthIntegrationCredentialsTypeToJSONTyped,
} from './PalAuthIntegrationCredentialsType';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
    InsurancePayorToJSONTyped,
} from './InsurancePayor';
import type { PalAuthPlatform } from './PalAuthPlatform';
import {
    PalAuthPlatformFromJSON,
    PalAuthPlatformFromJSONTyped,
    PalAuthPlatformToJSON,
    PalAuthPlatformToJSONTyped,
} from './PalAuthPlatform';

/**
 * 
 * @export
 * @interface PalAuthIntegration
 */
export interface PalAuthIntegration {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    auth_platform_id: string;
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    credentials_type: PalAuthIntegrationCredentialsType;
    /**
     * 
     */
    payor?: InsurancePayor;
    /**
     * 
     */
    auth_platform?: PalAuthPlatform;
}



/**
 * Check if a given object implements the PalAuthIntegration interface.
 */
export function instanceOfPalAuthIntegration(value: object): value is PalAuthIntegration {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('auth_platform_id' in value) || value['auth_platform_id'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('credentials_type' in value) || value['credentials_type'] === undefined) return false;
    return true;
}

export function PalAuthIntegrationFromJSON(json: any): PalAuthIntegration {
    return PalAuthIntegrationFromJSONTyped(json, false);
}

export function PalAuthIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthIntegration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'payor_id': json['payor_id'],
        'auth_platform_id': json['auth_platform_id'],
        'enabled': json['enabled'],
        'credentials_type': PalAuthIntegrationCredentialsTypeFromJSON(json['credentials_type']),
        'payor': json['payor'] == null ? undefined : InsurancePayorFromJSON(json['payor']),
        'auth_platform': json['auth_platform'] == null ? undefined : PalAuthPlatformFromJSON(json['auth_platform']),
    };
}

export function PalAuthIntegrationToJSON(json: any): PalAuthIntegration {
    return PalAuthIntegrationToJSONTyped(json, false);
}

export function PalAuthIntegrationToJSONTyped(value?: PalAuthIntegration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'payor_id': value['payor_id'],
        'auth_platform_id': value['auth_platform_id'],
        'enabled': value['enabled'],
        'credentials_type': PalAuthIntegrationCredentialsTypeToJSON(value['credentials_type']),
        'payor': InsurancePayorToJSON(value['payor']),
        'auth_platform': PalAuthPlatformToJSON(value['auth_platform']),
    };
}

